import React from 'react'
import className from 'classnames/bind'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'

import style from './MyhouseManagementFeeDetail.module.scss'

import ArrowDown10x6 from '@Ui/images/myhouse/ArrowDown10x6.svg'
import AverageMaintenanceCost from '@Types/entities/AverageMaintenanceCost'
import ComplexMaintenanceCost from '@Types/entities/ComplexMaintenanceCost'
import { formatMoneyBasedOnWon, MONEY_FORMAT_TYPE } from '@Root/utils/moneyFormatter'
import MyhouseManagementFeeEmpty from '@Components/atoms/MyhouseManagementFeeEmpty'

const cx = className.bind(style)

type Props = {
  isAverageExpanded?: boolean
  isMonthlyExpanded?: boolean
  averageMaintenanceCost?: AverageMaintenanceCost
  maintenanceCostList?: ComplexMaintenanceCost[]
  onAverageButtonClick?: any
  onMonthlyButtonClick?: any
}

const MyhouseManagementFeeDetail: React.FC<Props> = ({
  isAverageExpanded,
  isMonthlyExpanded,
  onAverageButtonClick,
  onMonthlyButtonClick,
  averageMaintenanceCost,
  maintenanceCostList,
}: Props) => {
  const recentMaintenanceCost = maintenanceCostList?.[0] || null

  if (isEmpty(maintenanceCostList)) {
    return <MyhouseManagementFeeEmpty />
  }

  return (
    <div className={cx('article')}>
      <div className={cx('average')}>
        <div className={cx('item_main')}>
          <span className={cx('title')}>월 평균</span>
          <span className={cx('fee')}>{formatMoneyBasedOnWon(averageMaintenanceCost?.averageTotalPrice || 0, MONEY_FORMAT_TYPE.TAX)}</span>
        </div>
        {isAverageExpanded && (
          <>
            <div className={cx('item_detail')}>
              <span className={cx('title')}>하절기평균(6~8월)</span>
              <span className={cx('fee')}>{formatMoneyBasedOnWon(averageMaintenanceCost?.summerTotalPrice || 0, MONEY_FORMAT_TYPE.TAX)}</span>
            </div>
            <div className={cx('item_detail')}>
              <span className={cx('title')}>동절기평균(12~2월)</span>
              <span className={cx('fee')}>{formatMoneyBasedOnWon(averageMaintenanceCost?.winterTotalPrice || 0, MONEY_FORMAT_TYPE.TAX)}</span>
            </div>
          </>
        )}
        <button type="button" className={cx('button_expand', isAverageExpanded && 'is_expanded')} onClick={onAverageButtonClick}>
          <ArrowDown10x6 />
          <span className={cx('blind')}>{isAverageExpanded ? '접기' : '펼치기'}</span>
        </button>
      </div>
      <div className={cx('monthly')}>
        {recentMaintenanceCost && (
          <div className={cx('item_main')}>
            <span className={cx('title')}>{dayjs(recentMaintenanceCost.basisYearMonth).format('YYYY년 MM월')}</span>
            <span className={cx('fee')}>{formatMoneyBasedOnWon(recentMaintenanceCost.totalPrice || 0, MONEY_FORMAT_TYPE.TAX)}</span>
          </div>
        )}
        <ul>
          {maintenanceCostList
            ?.filter((maintenanceCost, index) => (isMonthlyExpanded || index < 3) && index > 0)
            ?.map((maintenanceCost, index) => {
              const { basisYearMonth, totalPrice } = maintenanceCost
              return (
                <li className={cx('item_detail')} key={index}>
                  <span className={cx('title')}>{dayjs(basisYearMonth).format('YYYY년 MM월')}</span>
                  <span className={cx('fee')}>{formatMoneyBasedOnWon(totalPrice || 0, MONEY_FORMAT_TYPE.TAX)}</span>
                </li>
              )
            })}
        </ul>
        <button type="button" className={cx('button_expand', isMonthlyExpanded && 'is_expanded')} onClick={onMonthlyButtonClick}>
          <ArrowDown10x6 />
          <span className={cx('blind')}>{isMonthlyExpanded ? '접기' : '펼치기'}</span>
        </button>
      </div>
    </div>
  )
}

export default MyhouseManagementFeeDetail
